/*
 * Slideshow button positions (Akshay Fix 9, 2026-10-14).
 *
 * A slide can place its Dealer Login / Apply for Account buttons at a percent of the slide
 * image (CSS custom properties --login-x-d, --login-y-d, ... set by sections/slideshow.liquid).
 * The image fills the slide with object-fit: cover, so on screens whose shape differs from
 * the image, part of it is cropped and a percent of the slide is no longer the same spot on
 * the artwork. This script works out where the image really sits and moves each button to
 * that spot, then keeps it inside the slide. Without it the CSS percent placement still
 * applies.
 */
(function () {
  if (window.oewSlideshowButtonPosition) return;
  window.oewSlideshowButtonPosition = true;

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var EDGE = 8; // px kept clear between a button and the slide edge
  var GAP = 12; // px kept between Dealer Login and Apply for Account when they would overlap
  var BUTTONS = [
    ['login', 'a.slideshow-btn-login'],
    ['apply', 'a.slideshow-btn-apply'],
  ];

  function readNumber(styles, name) {
    var value = parseFloat(styles.getPropertyValue(name));
    return isNaN(value) ? null : value;
  }

  // object-position is "50% 50%" by default; px values are not used by this theme.
  function readObjectPosition(image) {
    var parts = image ? getComputedStyle(image).objectPosition.split(' ') : [];
    var fraction = function (part) {
      var value = parseFloat(part);
      return part && part.indexOf('%') > -1 && !isNaN(value) ? value / 100 : 0.5;
    };
    return [fraction(parts[0]), fraction(parts[1])];
  }

  function place(wrapper) {
    var device = mobileQuery.matches ? 'm' : 'd';
    var slide = wrapper.closest('.slideshow-slide');
    if (!slide) return;
    var image = slide.querySelector('.slideshow-media img');
    var styles = getComputedStyle(wrapper);
    var aspect = parseFloat(wrapper.getAttribute('data-aspect-' + device));
    if (image && image.naturalWidth && image.naturalHeight) {
      aspect = image.naturalWidth / image.naturalHeight;
    }

    var positions = {};
    BUTTONS.forEach(function (entry) {
      var button = wrapper.querySelector(':scope > ' + entry[1]);
      if (!button) return;
      var x = readNumber(styles, '--' + entry[0] + '-x-' + device);
      var y = readNumber(styles, '--' + entry[0] + '-y-' + device);
      var placed = wrapper.classList.contains('is-' + entry[0] + '-' + device);
      if (!placed || x === null || y === null || !button.offsetParent) {
        button.style.removeProperty('left');
        button.style.removeProperty('top');
        return;
      }

      var frame = button.offsetParent.getBoundingClientRect();
      // A slide that is not showing yet has a lazy image that is still 0 x 0. The image
      // always fills the slide, so measure the slide until it loads (the aspect comes from
      // data-aspect-*); otherwise the buttons land in the top-left corner (2026-10-19).
      var imageBox = image ? image.getBoundingClientRect() : null;
      var box = imageBox && imageBox.width > 0 && imageBox.height > 0 ? imageBox : slide.getBoundingClientRect();
      var drawnWidth = box.width;
      var drawnHeight = box.height;
      var offsetX = 0;
      var offsetY = 0;

      if (aspect > 0 && box.width > 0 && box.height > 0) {
        var fit = image ? getComputedStyle(image).objectFit : 'cover';
        var widthScale = box.width / aspect;
        // cover: the image is scaled up until it fills the box; contain: until it fits.
        var useWidth = fit === 'contain' ? widthScale <= box.height : widthScale >= box.height;
        drawnWidth = useWidth ? box.width : box.height * aspect;
        drawnHeight = useWidth ? box.width / aspect : box.height;
        var position = readObjectPosition(image);
        offsetX = (box.width - drawnWidth) * position[0];
        offsetY = (box.height - drawnHeight) * position[1];
      }

      var left = box.left - frame.left + offsetX + (x / 100) * drawnWidth;
      var top = box.top - frame.top + offsetY + (y / 100) * drawnHeight;

      // Keep the whole button inside the visible slide.
      var slideBox = slide.getBoundingClientRect();
      var minLeft = slideBox.left - frame.left + EDGE;
      var minTop = slideBox.top - frame.top + EDGE;
      var maxLeft = slideBox.right - frame.left - button.offsetWidth - EDGE;
      var maxTop = slideBox.bottom - frame.top - button.offsetHeight - EDGE;
      left = Math.max(minLeft, Math.min(left, maxLeft));
      top = Math.max(minTop, Math.min(top, maxTop));

      button.style.left = Math.round(left) + 'px';
      button.style.top = Math.round(top) + 'px';
      positions[entry[0]] = { button: button, left: left, top: top, maxTop: maxTop };
    });

    // On narrow screens the artwork is cropped, so keeping both buttons inside the slide can
    // push Apply for Account on top of Dealer Login (820 px, 2026-10-19). If they would
    // overlap, put Apply directly under Dealer Login instead.
    var login = positions.login;
    var apply = positions.apply;
    if (login && apply) {
      var lw = login.button.offsetWidth, lh = login.button.offsetHeight;
      var aw = apply.button.offsetWidth, ah = apply.button.offsetHeight;
      var overlaps = apply.left < login.left + lw + GAP && login.left < apply.left + aw + GAP &&
        apply.top < login.top + lh + GAP && login.top < apply.top + ah + GAP;
      if (overlaps) {
        var below = Math.min(login.top + lh + GAP, apply.maxTop);
        apply.button.style.left = Math.round(login.left) + 'px';
        apply.button.style.top = Math.round(below) + 'px';
      }
    }
  }

  function placeAll(root) {
    (root || document).querySelectorAll('.slideshow-buttons[data-btn-position]').forEach(place);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      placeAll();
    });
  }

  function watch(root) {
    (root || document).querySelectorAll('.slideshow-buttons[data-btn-position]').forEach(function (wrapper) {
      var slide = wrapper.closest('.slideshow-slide');
      if (!slide || slide.dataset.btnPositionWatched) return;
      slide.dataset.btnPositionWatched = 'true';
      if (window.ResizeObserver) new ResizeObserver(schedule).observe(slide);
      var image = slide.querySelector('.slideshow-media img');
      // Also fires when <picture> swaps to the mobile image at the breakpoint.
      if (image) image.addEventListener('load', schedule);
      wrapper.querySelectorAll('a').forEach(function (button) {
        if (window.ResizeObserver) new ResizeObserver(schedule).observe(button);
      });
    });
    schedule();
  }

  function init() {
    watch();
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    // Theme editor: sections and blocks are re-rendered in place.
    document.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
    document.addEventListener('shopify:block:select', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
